import { Alfajores, ContractKitProvider, NetworkNames } from '@celo-tools/use-contractkit';
import '@celo-tools/use-contractkit/lib/styles.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './styles/global.css';
import './styles/index.css';
import './styles/tailwind.css';

ReactDOM.render(
  <React.StrictMode>
    <ContractKitProvider
      networks={[Alfajores]}
      network={{
        name: NetworkNames.Alfajores,
        rpcUrl: 'https://alfajores-forno.celo-testnet.org',
        graphQl: 'https://alfajores-blockscout.celo-testnet.org/graphiql',
        explorer: 'https://alfajores-blockscout.celo-testnet.org',
        chainId: 44787,
      }}
      dapp={{
        name: 'Celo React Boilerplate',
        description: 'A React Boilerplate for Celo Dapps',
        url: ' ',
        icon: ' ',
      }}
    >
      <App />
    </ContractKitProvider>
  </React.StrictMode>,

  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
